<div
    #container
    [ngClass]="{
        disappear: highQualityLoaded,
        'zoom-image-container': true
    }"
    [tabIndex]="tabIndex$ | async"
    [style.cursor]="cursor$ | async"
    (keydown)="panByKeyDown($event)"
    [ngStyle]="{
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
        'background-position': 'center',
        'background-image': 'url(' + lowQualityUrl + ')'
    }">
    <img
        hI18nAsset
        alt=""
        id="high"
        [class.appear]="highQualityLoaded"
        [style.transform]="transform$ | async"
        [attr.src]="highQualityUrl"
        [hImageErrorDefault]="lowQualityUrl"
        [tag]="asset.tag"
        [imageTitle]="product.title"
        [url]="asset.url"
        [hI18nAttr]="'alt'"
        (defaultErrored)="onAssetLoadError()"
        (mousedown)="onMouseDown($event)"
        (touchstart)="onTouchStart($event)"
        (touchmove)="onTouchMove($event)"
        (pointerdown)="onPointerDown($event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp($event)"
        (load)="handleHighQualityLoaded($event)" />
</div>
